
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.385 5A1.392 1.392 0 003 6.4v11.2A1.392 1.392 0 004.385 19h15.23A1.393 1.393 0 0021 17.6V6.4A1.394 1.394 0 0019.615 5H4.385zm13.616 2.1a1.4 1.4 0 11-1.282.866 1.393 1.393 0 011.282-.866zM7.846 9.6a1.66 1.66 0 011.184.5l2.258 2.283.712.717.8.809a.741.741 0 001.056 0 .764.764 0 000-1.072l-.8-.805.526-.532a1.661 1.661 0 012.369 0l3.469 3v3H4.58v-5.8l2.082-1.6a1.66 1.66 0 011.184-.5z"}})])
          )
        }
      }
    